import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAllSalaryReportDetailsByDepartment = createAsyncThunk(
  "report/fetchAllPaySlipReportDetailsByDepartment",
  async (
    {
      startDate,
      endDate,
      departmentId,
    }: {
      startDate: string;
      endDate: string;
      departmentId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        "/report/salary/department",
        {
          params: {
            startDate,
            endDate,
            departmentId,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data ||
          "Failed to fetch Salary Report Details by Department"
      );
    }
  }
);
export const fetchAllSalaryReportDetailsByDepartmentCount = createAsyncThunk(
  "report/fetchAllPaySlipReportDetailsByDepartmentCount",
  async (
    {
      startDate,
      endDate,
      departmentId,
    }: {
      startDate: string;
      endDate: string;
      departmentId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        "/report/salary/details/count",
        {
          params: {
            startDate,
            endDate,
            departmentId,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data ||
          "Failed to fetch Salary Report Details by Department Count"
      );
    }
  }
);
export const fetchAllSalaryReportDetailsByDepartmentCountMonthly = createAsyncThunk(
  "report/fetchAllPaySlipReportDetailsByDepartmentCount",
  async (
    {
      startDate,
      endDate,
      departmentId,
    }: {
      startDate: string;
      endDate: string;
      departmentId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        "/report/salary/details/monthly",
        {
          params: {
            startDate,
            endDate,
            departmentId,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data ||
          "Failed to fetch Salary Report Details by Department Count"
      );
    }
  }
);